import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { buildEndpoint } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';

const useContractArticleOptionService = () => {
    const { doGet, doPost } = useFetch();

    const [fetchingAll, setFetchingAll] = useState(false);
    const [fetchingStore, setFetchingStore] = useState(false);
    const [fetchingUpdate, setFetchingUpdate] = useState(false);
    const [fetchingDelete, setFetchingDelete] = useState(false);

    /**
     * Obtener todas las alternativas de un artículo
     */
    const getAllOptions = (articleId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/articles/${articleId}/options`),
            setFetching: setFetchingAll
        });
    };

    /**
     * Crear nueva alternativa
     */
    const storeOption = (data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint('app/contract-drafting/admin/article-options/store'),
            body: data,
            setFetching: setFetchingStore
        });
    };

    /**
     * Actualizar alternativa
     */
    const updateOption = (id: number, data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/article-options/${id}/update`),
            body: data,
            setFetching: setFetchingUpdate
        });
    };

    /**
     * Eliminar alternativa
     */
    const deleteOption = (id: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/article-options/${id}/delete`),
            setFetching: setFetchingDelete
        });
    };

    return {
        getAllOptions,
        storeOption,
        updateOption,
        deleteOption,
        fetchingAll,
        fetchingStore,
        fetchingUpdate,
        fetchingDelete,
    };
};

export default useContractArticleOptionService;

